export const equipmentConfig = {
    dccircuit: {
        name: 'DC Circuit',
        type: 'dccircuit',
        assetsType: 'DCT',
        assetTypeName: 'DC Circuit',

        uniqueFieldName: 'track_number',
        uniqueFieldRequest: 'trackNumber',

        extraField: {
            label: 'Track Number',
            name: 'trackNumber',
            type: 'text',
            placeholder: 'Enter track number',
        },
    },

    pointmachine: {
        name: 'Point Machine',
        type: 'pointmachine',
        assetsType: 'PM',
        assetTypeName: 'Point Machine',
        uniqueFieldName: 'point_machine',
        uniqueFieldRequest: 'pointMachine',

        extraField: {
            label: 'Point Machine',
            name: 'pointMachine',
            type: 'text',
            placeholder: 'Enter point machine',
        },
    },
    batterycharger: {
        name: 'Battery Charger',
        type: 'batterycharger',
        assetsType: 'BC',
        assetTypeName: 'Battery Charger',
        uniqueFieldName: 'battery_charger',
        uniqueFieldRequest: 'batteryCharger',

        extraField: {
            label: 'Battery Charger',
            name: 'batteryCharger',
            type: 'text',
            placeholder: 'Enter battery charger',
        },
    },
    ips: {
        name: 'IPS',
        type: 'ipsnumber',
        assetsType: 'IPS',
        assetTypeName: 'IPS',
        uniqueFieldName: 'ips_number',
        uniqueFieldRequest: 'ipsNumber',

        extraField: {
            label: 'IPS',
            name: 'ipsNumber',
            type: 'text',
            placeholder: 'Enter ips number',
        },
    },
    hassdac: {
        name: 'HASSDAC',
        type: 'hassdacnumber',
        assetsType: 'HASSDAC',
        assetTypeName: 'HASSDAC',
        uniqueFieldName: 'hassdac_number',
        uniqueFieldRequest: 'hassdacNumber',

        extraField: {
            label: 'HASSDAC',
            name: 'hassdacNumber',
            type: 'text',
            placeholder: 'Enter hassdac number',
        },
    },
    relay: {
        name: 'Relay',
        type: 'relaynumber',
        assetsType: 'RELAY',
        assetTypeName: 'Relay',
        uniqueFieldName: 'relay_number',
        uniqueFieldRequest: 'relayNumber',

        extraField: {
            label: 'Relay',
            name: 'relayNumber',
            type: 'text',
            placeholder: 'Enter relay number',
        },
    },
    spd: {
        name: 'Spd',
        type: 'spdnumber',
        assetsType: 'SPD',
        assetTypeName: 'Spd',
        uniqueFieldName: 'spd_number',
        uniqueFieldRequest: 'spdNumber',

        extraField: {
            label: 'Spd',
            name: 'spdNumber',
            type: 'text',
            placeholder: 'Enter spd number',
        },
    },
    outdoor: {
        name: 'Outdoor',
        type: 'outdoor',
        assetsType: 'OD',
        assetTypeName: 'Outdoor',
        uniqueFieldName: 'out_door',
        uniqueFieldRequest: 'outDoor',

        extraField: {
            label: 'Outdoor',
            name: 'outDoor',
            type: 'text',
            placeholder: 'Enter out door',
        },
    },
    ufsbi: {
        name: 'Ufsbi',
        type: 'ufsbinumber',
        assetsType: 'US',
        assetTypeName: 'Ufsbi',
        uniqueFieldName: 'ufsbi_number',
        uniqueFieldRequest: 'ufsbiNumber',

        extraField: {
            label: 'Ufsbi',
            name: 'ufsbiNumber',
            type: 'text',
            placeholder: 'Enter ufsbi number',
        },
    },
    signal: {
        name: 'Signal',
        type: 'signal',
        assetsType: 'SG',
        assetTypeName: 'Signal',
        uniqueFieldName: 'signal_number',
        uniqueFieldRequest: 'signalNumber',

        extraField: {
            label: 'Signal',
            name: 'signalNumber',
            type: 'text',
            placeholder: 'Enter signal number',
        },
    },
    callingonsignal: {
        name: 'Callingon Signal',
        type: 'callingonsignal',
        assetsType: 'COS',
        assetTypeName: 'Callingon Signal',
        uniqueFieldName: 'callingon_signal',
        uniqueFieldRequest: 'callingonSignal',

        extraField: {
            label: 'Callingon Signal',
            name: 'callingonSignal',
            type: 'text',
            placeholder: 'Enter callingon signal',
        },
    },
    routesignal: {
        name: 'Route Signal',
        type: 'routesignal',
        assetsType: 'RS',
        assetTypeName: 'Route Signal',
        uniqueFieldName: 'route_signal',
        uniqueFieldRequest: 'routeSignal',

        extraField: {
            label: 'Route Signal',
            name: 'routeSignal',
            type: 'text',
            placeholder: 'Enter route signal',
        },
    },
    shuntsignal: {
        name: 'Shunt Signal',
        type: 'shuntsignal',
        assetsType: 'SS',
        assetTypeName: 'Shunt Signal',
        uniqueFieldName: 'shunt_signal',
        uniqueFieldRequest: 'shuntSignal',

        extraField: {
            label: 'Shunt Signal',
            name: 'shuntSignal',
            type: 'text',
            placeholder: 'Enter shunt signal',
        },
    },
    axlecounter: {
        name: 'Axle Counter',
        type: 'axlecounter',
        assetsType: 'AC',
        assetTypeName: 'Axle Counter',
        uniqueFieldName: 'axle_counter',
        uniqueFieldRequest: 'axleCounter',

        extraField: {
            label: 'Axle Counter',
            name: 'axleCounter',
            type: 'text',
            placeholder: 'Enter axle counter',
        },
    },
    relayroom: {
        name: 'Relay Room',
        type: 'relayroom',
        assetsType: 'RR',
        assetTypeName: 'Relay Room',
        uniqueFieldName: 'relay_room',
        uniqueFieldRequest: 'relayRoom',

        extraField: {
            label: 'Relay Room',
            name: 'relayRoom',
            type: 'text',
            placeholder: 'Enter relay room',
        },
    },
    batteryroom: {
        name: 'Battery Room',
        type: 'batteryroom',
        assetsType: 'BR',
        assetTypeName: 'Battery Room',
        uniqueFieldName: 'battery_room',
        uniqueFieldRequest: 'batteryRoom',

        extraField: {
            label: 'Battery Room',
            name: 'batteryRoom',
            type: 'text',
            placeholder: 'Enter battery room',
        },
    },
    maintainerroom: {
        name: 'Maintainer Room',
        type: 'maintainerroom',
        assetsType: 'MR',
        assetTypeName: 'Maintainer Room',
        uniqueFieldName: 'maintainer_room',
        uniqueFieldRequest: 'maintainerRoom',

        extraField: {
            label: 'Maintainer Room',
            name: 'maintainerRoom',
            type: 'text',
            placeholder: 'Enter maintainer room',
        },
    },
    generatorroom: {
        name: 'Generator Room',
        type: 'generatorroom',
        assetsType: 'GR',
        assetTypeName: 'Generator Room',
        uniqueFieldName: 'generator_room',
        uniqueFieldRequest: 'generatorRoom',

        extraField: {
            label: 'Generator Room',
            name: 'generatorRoom',
            type: 'text',
            placeholder: 'Enter generator room',
        },
    },
    ipsroom: {
        name: 'Ips Room',
        type: 'ipsroom',
        assetsType: 'IPSR',
        assetTypeName: 'Ips Room',
        uniqueFieldName: 'ips_room',
        uniqueFieldRequest: 'ipsRoom',

        extraField: {
            label: 'Ips Room',
            name: 'ipsRoom',
            type: 'text',
            placeholder: 'Enter ips room',
        },
    },
    locationbox: {
        name: 'Location Box',
        type: 'locationbox',
        assetsType: 'LB',
        assetTypeName: 'Location Box',
        uniqueFieldName: 'location_box',
        uniqueFieldRequest: 'locationBox',

        extraField: {
            label: 'Location Box',
            name: 'locationBox',
            type: 'text',
            placeholder: 'Enter location box',
        },
    },
    earthleakagedetector: {
        name: 'Earth Leakage Detector',
        type: 'earthleakagedetector',
        assetsType: 'ELD',
        assetTypeName: 'Earth Leakage Detector',
        uniqueFieldName: 'earthleakage_detector',
        uniqueFieldRequest: 'earthleakageDetector',

        extraField: {
            label: 'Earth Leakage Detector',
            name: 'earthleakageDetector',
            type: 'text',
            placeholder: 'Enter earthleakage detector',
        },
    },
    electricliftingbarrier: {
        name: 'Electric Lifting Barrier',
        type: 'electricliftingbarrier',
        assetsType: 'ELB',
        assetTypeName: 'Electric Lifting Barrier',
        uniqueFieldName: 'electriclifting_barrier',
        uniqueFieldRequest: 'electricliftingBarrier',

        extraField: {
            label: 'Electric Lifting Barrier',
            name: 'electricliftingBarrier',
            type: 'text',
            placeholder: 'Enter earthleakage barrier',
        },
    },
    audiofrequencytc: {
        name: 'Audio Frequency TC',
        type: 'audiofrequencytc',
        assetsType: 'AFTC',
        assetTypeName: 'Audio Frequency TC',
        uniqueFieldName: 'aftc_number',
        uniqueFieldRequest: 'aftcNumber',

        extraField: {
            label: 'Audio Frequency TC',
            name: 'aftcNumber',
            type: 'text',
            placeholder: 'Enter audio frequency tc',
        },
    },
    mechanicallcgate: {
        name: 'Mechanical LC Gate',
        type: 'mechanicallcgate',
        assetsType: 'MLC',
        assetTypeName: 'Mechanical LC Gate',
        uniqueFieldName: 'mlc_number',
        uniqueFieldRequest: 'mlcNumber',

        extraField: {
            label: 'Mechanical LC Gate',
            name: 'mlcNumber',
            type: 'text',
            placeholder: 'Enter mechanical lc gate',
        },
    },
};

export const equipmentRoomTypes = [
    {
        eqpmntroom_name: 'Relay Room',
        eqpmntroom_type_code: 'RR',
        eqpmntroom_type_id: 'F0',
    },
    {
        eqpmntroom_name: 'IPS Room',
        eqpmntroom_type_code: 'IPS',
        eqpmntroom_type_id: 'F1',
    },
    {
        eqpmntroom_name: 'Battery Room',
        eqpmntroom_type_code: 'BATT',
        eqpmntroom_type_id: 'F2',
    },
    {
        eqpmntroom_name: 'Maintainer Room',
        eqpmntroom_type_code: 'MAIN',
        eqpmntroom_type_id: 'F3',
    },
    {
        eqpmntroom_name: 'Generator Room',
        eqpmntroom_type_code: 'GEN',
        eqpmntroom_type_id: 'F4',
    },
    {
        eqpmntroom_name: 'Outdoor',
        eqpmntroom_type_code: 'OUTDOOR',
        eqpmntroom_type_id: 'F5',
    },
    {
        eqpmntroom_name: 'Location Box',
        eqpmntroom_type_code: 'LOC',
        eqpmntroom_type_id: 'F6',
    },
];
